var FUNCTION_TYPE = "function";
var ColorSchemes = {
  DARK: "dark",
  LIGHT: "light",
  LIGHT_HIGH_CONTRAST: "light_high_contrast"
};

export { ColorSchemes, FUNCTION_TYPE };
